import React from "react";
import style from "./style.module.scss";
import Link from "src/shared-features/Link";
import { Button } from "@evvve/ui-kit";
import { useAppDispatch, useAppSelector } from "src/hooks/useStoreHooks";
import { logout } from "src/store/User/slice";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../../../../authorization/service/api";

const { wrap, close, divider } = style;

export interface Props {
  openMenu?: boolean;
}

const HeaderMenu = ({ openMenu }: Props) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(
    (state) => state.user.userInfo
  );
  const navigate = useNavigate();
  const [logoutAndInvalidateCaches] = useLogoutMutation();
  return (
    <div className={openMenu ? wrap : close}>
      <Link to={`/profile/${user?.username}`} hoverUnderLine={false} color="violet">
                    Profile
      </Link>
      <hr className={`${divider} solid`} />
      <Link to="/" hoverUnderLine={false} color="violet">
                Homepage
      </Link>
      <Link to="/catalog" hoverUnderLine={false} color="violet">
                Event catalog
      </Link>
      <Link to="/contacts" hoverUnderLine={false} color="violet">
            Contacts
      </Link>
      <hr className={`${divider} solid`} />
      <Link to="/privacy" hoverUnderLine={false} color="violet">
                Privacy Policy
      </Link>
      <Link to="/terms" hoverUnderLine={false} color="violet">
          Terms of Service
      </Link>
      {/*<Link to="/learning" hoverUnderLine={false} color="violet">*/}
      {/*          Learning*/}
      {/*</Link>*/}
      <hr className={`${divider} solid`} />
      <Button theme="red" type="flat" size="s" onClick={async () => {
        navigate("/");
        dispatch(logout());
        await logoutAndInvalidateCaches().unwrap();
      }}>
                Log out
      </Button>
    </div>
  );
};
export default HeaderMenu;